// extracted by mini-css-extract-plugin
module.exports = {"category":"category__q3SCR","setByClient":"setByClient__alUyc"};